import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, clearError } from "../../redux/authSlice";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GoogleSignInButton from "./GoogleSignInButton";
import "./login.css";

const LogIn = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const dispatch = useDispatch();
    const { loading, error, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    // auth.error survives until the next attempt STARTS, so a failure carried over from another
    // page would render here on arrival. That matters more now that the message can be a
    // rate-limit countdown ("wait 45 seconds"), which is actively wrong once the wait has passed.
    // Register.js already does this; the login page never did.
    useEffect(() => {
      dispatch(clearError());
    }, [dispatch]);

    const handleSubmit = async (e) => {
      e.preventDefault();
      const result = await dispatch(loginUser({ email, password }));

      if (loginUser.fulfilled.match(result)) {
        navigate("/home");
      }
    
    };
  
    return (
      <div className="login-container">
        <h2>Login</h2>
        {error && <p className="error-message">{error}</p>}
        {token ? <p>Welcome!</p> : null}
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <GoogleSignInButton text="signin_with" />
        <p>Don't have an account? <Link to="/register">Register here</Link></p>
      </div>
    );
  };
  
  export default LogIn;
